import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.61719 7.35291C8.06525 5.73518 9.71506 4.72217 12.3069 4.72217C17.13 4.72217 18.6909 8.22988 21.7602 12.6145C20.18 14.8719 18.9996 16.8969 17.5681 18.3304",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.8119 19.6764C14.8416 20.2082 13.712 20.507 12.3047 20.507C7.48165 20.507 5.92084 16.9993 2.85156 12.6147C3.73569 11.3517 4.4946 10.1615 5.24232 9.10693",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.40234 2.71143L22.2086 22.5177",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M14.1657 14.4748C15.1931 13.4474 15.1931 11.7819 14.1657 10.7544C13.1384 9.72706 11.4727 9.72706 10.4453 10.7544",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }